import { ValueConverter } from '@shared/execution/types';
import { ProviderType } from '@shared/types/flowstep';
import { BypassValueConverter } from './bypass-value-converter';
import { HubspotValueConverter } from './hubspot-value-converter';
import { SalesforceReportConverter } from './salesforce-report-converter';

type ValueConverterConstructor = new () => ValueConverter;

const converters: { [key in ProviderType]: ValueConverterConstructor } = {
  [ProviderType.SF]: BypassValueConverter,
  [ProviderType.HS]: HubspotValueConverter,
  [ProviderType.CSV]: BypassValueConverter,
  [ProviderType.HubspotList]: HubspotValueConverter,
  [ProviderType.SalesforceReport]: SalesforceReportConverter,
  [ProviderType.SalesforceDebugReport]: BypassValueConverter,
  [ProviderType.SalesforceSoql]: SalesforceReportConverter,
};

export class ValueConverterFactory {
  getValueConverter(provider: ProviderType): ValueConverter {
    const ConverterClass = converters[provider];
    return new ConverterClass();
  }
}
